import React, { useContext, useEffect, useRef, useState, useMemo } from "react";
import Pagination from "components/Pagination/Pagination";
import TableOrder from "components/Tables/TableOrder";
import { HeaderSearch } from "styled/SectionContainer.styled";
import {
  arrayLeftTreasuryExtract,
  arrayLeftTreasuryExtractUser,
  arrayRigthTreasuryExtract,
  arrayRigthTreasuryExtractUser,
  TitleExtract
} from "../ArrayList/ArrayList";
import { Title } from "styled/Title";
import { ModalGeneric } from "components/modal/ModalGeneric";
import { SearchAdvancedModule } from "components/SearchSimpleAdvanced/SearchAdvancedModule";
import { ExportDetail } from "pages/CustomsClearance/Adjunto/ExportDetail";
import { useModal } from "hooks/useModal";
import { useForm } from "hooks/useForm";
import TBodyExtract from "../Tables/TbodyExtract";
import { useSelector } from "react-redux";
import { AlertErrorAlert } from "components/Alerts/AlertErrorAlert";
import FormSearchExtract from "../Forms/FormSearchExtract";
import TreasuryCrudContex from "context/TreasuryContex";
import environment from "constants/apiConst";
import { AuthContext } from "context/AuthContext";
import TablesItems from "./view/TablesItems";
import { useDispatch } from "react-redux";
import { clearSearch, setSearch } from "redux/actions/searchActions";
import { ModalExportAdvance } from "components/ExportByColumn/ExportAdvance";
import { useSearchUrl } from "hooks/useSearchUrl";
import { useExtracts, useExtractsSearch } from "hooks/useExtracts";

const Extracts = () => {
  const { cleanState } = useSearchUrl({ getParams: ["date1", "date2", "code", "document", "valueDocument"], nestedProp: "searchAdvance" });
  const { state, clearParamsSearch } = useSearchUrl({ getParams: ["search", "valueQualified"], nestedProp: "searchSimple" });

  const [page, setPage] = useState(1);
  const [pageSearch, setPageSearch] = useState(1);
  const [isOpenSearch, onOpenSearch, onCloseSearch] = useModal();
  const [isOpenExport, onOpenExport, onCloseExport] = useModal();
  const [changeViewSearch, setChangeViewSearch] = useState(false);
  const [searcheAdvanced, setSearchAdvanced] = useState(cleanState);
  const [openAlert] = AlertErrorAlert();
  const { authUser } = useContext(AuthContext);
  const { token } = useSelector((state) => state.auth.dataUser);
  const { exportColumnBy, setRequestExport, onCloseModal, isOpenObservacion } =
    useContext(TreasuryCrudContex);
  const [values, handleInputChange, reset, setValues] = useForm({
    searchInformacion: state?.search || "",
    valueQualified: state?.valueQualified || [],
  });

  const { searchInformacion, valueQualified } = values;

  // React Query hooks
  const { data: extractsData, isLoading } = useExtracts(token, page, !changeViewSearch);
  
  // Preparar datos de búsqueda con useMemo para estabilizar
  const searchData = useMemo(() => ({
    ...(valueQualified && valueQualified?.value && {
      qualifiedUser_id: valueQualified?.value
    }),
    ...(searchInformacion && { search: searchInformacion }),
    ...searcheAdvanced
  }), [valueQualified, searchInformacion, searcheAdvanced]);
  
  // Hook de búsqueda con useQuery
  const { 
    data: searchData_result, 
    isLoading: isSearchLoading, 
    error: searchError
  } = useExtractsSearch(token, searchData, pageSearch, changeViewSearch && Object.keys(searchData).length > 0);
  
  // Ref para funciones de dispatch estables
  const dispatchSearchRef = useRef();
  const dispatchClearSearchRef = useRef();
  const lastSearchDataRef = useRef(null);
  const shouldResetPageRef = useRef(false);
  const lastQualifiedUserIdRef = useRef(null);

  const backSearch = () => {
    clearParamsSearch({ searchArray: ["searchAdvance", "searchSimple"] });
    reset();
    setSearchAdvanced([]);
    setChangeViewSearch(false);
  };

  const handleSubmit = (data, formulario) => {
    const info = {
      fields: formulario,
      data
    };
    exportColumnBy(info, onCloseExport);
  };

  const dispatchRedux = useDispatch();
  
  // Configurar funciones de dispatch en refs para evitar bucles
  dispatchSearchRef.current = (data) => {
    dispatchRedux(setSearch(data));
  };
  
  dispatchClearSearchRef.current = () => {
    dispatchRedux(clearSearch());
  };

  // useEffect simplificado para manejar cambios de búsqueda
  useEffect(() => {
    const searchDataString = JSON.stringify(searchData);
    const lastSearchDataString = lastSearchDataRef.current ? JSON.stringify(lastSearchDataRef.current) : null;
    
    // Solo ejecutar si los datos realmente han cambiado
    if (searchDataString !== lastSearchDataString) {
      lastSearchDataRef.current = searchData;
      
      // Si hay datos de búsqueda, activar modo búsqueda
      if (Object.keys(searchData).length > 0) {
        setChangeViewSearch(true);
        shouldResetPageRef.current = true; // Marcar para resetear página
        dispatchSearchRef.current(searchData);
        onCloseSearch();
      } else {
        // Si no hay datos de búsqueda, limpiar modo búsqueda
        setChangeViewSearch(false);
        shouldResetPageRef.current = true; // Marcar para resetear página
        dispatchClearSearchRef.current();
      }
    }
  }, [searchData, onCloseSearch]);

  // useEffect para resetear página cuando cambien los parámetros de búsqueda
  useEffect(() => {
    if (shouldResetPageRef.current && changeViewSearch) {
      setPageSearch(1);
      shouldResetPageRef.current = false;
    }
  }, [changeViewSearch]);

  // useEffect específico para detectar cambios en usuario calificado
  useEffect(() => {
    const currentQualifiedUserId = valueQualified?.value || null;
    const lastQualifiedUserId = lastQualifiedUserIdRef.current;
    
    // Si el usuario calificado ha cambiado y estamos en modo búsqueda, resetear página
    if (currentQualifiedUserId !== lastQualifiedUserId && changeViewSearch) {
      setPageSearch(1);
    }
    
    // Actualizar el ref con el valor actual
    lastQualifiedUserIdRef.current = currentQualifiedUserId;
  }, [valueQualified, changeViewSearch]);

  // useEffect para manejar errores de búsqueda
  useEffect(() => {
    if (searchError) {
      if (searchError.message === "Acceso no autorizado.") {
        reset();
        setSearchAdvanced([]);
        setChangeViewSearch(false);
        openAlert(searchError.message, "error");
      } else {
        console.error('Error en búsqueda:', searchError);
      }
    }
  }, [searchError, reset, openAlert]);
  

  useEffect(() => {
    setRequestExport(environment.TREASURY_EXPORT_MODULE_EXPORT);
  }, [setRequestExport]);

  // useEffect para limpiar búsqueda al desmontar
  useEffect(() => {
    return () => dispatchClearSearchRef.current();
  }, []);

  const { user_rol, admin } = useSelector((state) => state.auth.dataUser);
  const [allAccess, setAllAccess] = useState(false);
  const [myPermission, setmyPermission] = useState(null);

  useEffect(() => {
    if (admin === 1) {
      setAllAccess(true);
    } else if (!allAccess) {
      const newArray = [];
      user_rol?.modules?.map((item) => {
        return item.permission.map((e) => newArray.push(e.name_permission));
      });
      setmyPermission(newArray);
    }
  }, [user_rol, allAccess, admin]);

  const calculateNodeList = {
    0: arrayLeftTreasuryExtract.concat(arrayRigthTreasuryExtract),
    1: arrayLeftTreasuryExtractUser.concat(arrayRigthTreasuryExtractUser),
  }[authUser.is_qualified_user];

  return (
    <>
      <Title style={{ marginTop: 30 }}>Extractos</Title>
      <ModalGeneric
        isOpen={isOpenObservacion}
        onClose={onCloseModal}
        title={"Detalle"}
        size={"5xl"}
      >
        <TablesItems />
      </ModalGeneric>

      <ModalGeneric
        isOpen={isOpenSearch}
        onClose={onCloseSearch}
        title={"Búsqueda avanzada"}
        scrollBehavior="outside"
      >
        <FormSearchExtract
          onClose={onCloseSearch}
          setSearchAdvanced={setSearchAdvanced}
        />
      </ModalGeneric>

      <ModalExportAdvance
        isOpen={isOpenExport}
        onOpen={onOpenExport}
        onClose={onCloseExport}
        title="Exportar documentos"
        handleSubmit={handleSubmit}
        nodeList={calculateNodeList}
        dafaulActive={["document_type_id"]}
        enableAdvance={true}
      />
      {/* <ModalGeneric
        isOpen={isOpenExport}
        onOpen={onOpenExport}
        onClose={onCloseExport}
        title={"Exportar documento"}
        size={"4xl"}
      >
        <ExporByColumn
          onClose={onCloseExport}
          ListLeft={
            authUser.is_qualified_user === 0
              ? arrayLeftTreasuryExtract
              : arrayLeftTreasuryExtractUser
          }
          listRight={
            authUser.is_qualified_user === 0
              ? arrayRigthTreasuryExtract
              : arrayRigthTreasuryExtractUser
          }
          handleSubmit={handleSubmit}
          dafaulActive={["document_type_id"]}
        />
      </ModalGeneric> */}

      <div className="container p-4">
        <SearchAdvancedModule
          handleInputChange={handleInputChange}
          values={values}
          onOpenSearch={onOpenSearch}
          changeViewSearch={changeViewSearch}
          backSearch={backSearch}
          permisoSearch={"getExtracts"}
          allAccess={allAccess}
          myPermission={myPermission}
          setValues={setValues}
        />
        <ExportDetail onOpen={onOpenExport} />
      </div>

      <HeaderSearch>
        {changeViewSearch
          ? (
            <div className="px-5">
              <div>
                <TableOrder
                  thead={TitleExtract}
                  data={searchData_result?.data || []}
                  setData={() => {}} // React Query maneja los datos
                  loading={isSearchLoading}
                  tbodyData={TBodyExtract}
                />

                <Pagination
                  page={pageSearch}
                  setPage={setPageSearch}
                  maxPage={searchData_result?.lastPage || 1}
                  loading={isSearchLoading}
                />
              </div>
            </div>
          )
          : (
            <div>
              <TableOrder
                thead={TitleExtract}
                data={extractsData?.data || []}
                setData={() => {}} // React Query maneja los datos
                loading={isLoading}
                tbodyData={TBodyExtract}
              />
              <Pagination
                page={page}
                setPage={setPage}
                maxPage={extractsData?.lastPage || 1}
                loading={isLoading}
              />
            </div>
          )}
      </HeaderSearch>
    </>
  );
};

export default Extracts;
